import ActionTypes from './actionType'


export function LoaderDispatch(){
    return {
        type: ActionTypes.EditLoader
    }
}

export function messageDispatch(payload){
    return {
        type: ActionTypes.EditMessage,
        payload
    }
}


// WEBPACK FOOTER //
// ./src/reducers/container/editDispatch.jsx